import { uniqBy } from 'lodash/fp';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import FilterGroup from '../../../StandardApplicationEntrypoint/CarListingPage/CarFilter/FilterGroup';
import { useCarListingState } from '../CarListingStateProvider';

const CarModelFilter = () => {
    const { t } = useTranslation(['carList']);
    const {
        state: { filters, modelFilter },
        actions,
    } = useCarListingState();

    const onChange = useCallback(
        (value: string[]) => {
            actions.setPage(1);
            actions.setScroll(false);
            actions.setModelFilter(value.length > 0 ? value : []);
        },
        [actions]
    );

    const options = useMemo(
        () =>
            uniqBy(
                'value',
                filters?.modelCategories.map(model => ({
                    label: model,
                    value: model,
                }))
            ),
        [filters?.modelCategories]
    );

    if (!options?.length || options.length === 1) {
        return null;
    }

    return (
        <FilterGroup
            onChange={onChange}
            options={options}
            title={t('carList:filter.carModelTitle')}
            value={modelFilter || []}
        />
    );
};

export default CarModelFilter;
